// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PartnerManualHeader h3{font-weight:700;font-size:17px;text-decoration:dashed underline;text-decoration-thickness:1px;margin-bottom:0}.PartnerManualHeader.--stripped h3{color:#333}.PartnerManualGrid{display:grid;grid-template-columns:repeat(auto-fill, minmax(300px, 1fr));grid-gap:20px;row-gap:20px}", ""]);
// Exports
module.exports = exports;
